/** @type {Styles} */

export const styles = {
  editorContainer: {
    width: '100%',
    '& .tox .tox-edit-area::before': {
      opacity: 0,
      border: 'none',
      display: 'none',
    },
    // Mobile-specific styles
    [(theme) => theme.breakpoints.down('sm')]: {
      '&& .tox.tox-tinymce': {
        minHeight: '140px', // Smaller minimum height on mobile
      },
      '& .tox-toolbar': {
        padding: '4px', // Smaller toolbar padding
      },
      '& .tox-toolbar__group': {
        marginRight: '2px', // Tighter spacing between toolbar groups
      },
      '& .tox-tbtn': {
        minWidth: '32px', // Smaller toolbar buttons
        minHeight: '32px',
        padding: '4px',
      },
      '& .tox-tbtn svg': {
        width: '16px', // Smaller icons
        height: '16px',
      },
    },
    '.hapana-rich-editor-wrapper .tox, .hapana-rich-editor-wrapper .tox *, .hapana-rich-editor-wrapper .tox *:focus, .hapana-rich-editor-wrapper .tox-edit-area__iframe':
      {
        outline: 'none',
        boxShadow: 'none',
      },
    '& .tox .tox-sidebar-wrap': {
      background: 'transparent',
    },
    '& .tox-editor-container': {
      background: 'transparent',
    },
    '&& .tox.tox-tinymce': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      borderRadius: '4px',
      boxShadow: 'none',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: (theme) => theme.typography.fontFamily,
      overflow: 'hidden',
      position: 'relative',
      visibility: 'inherit',
      transition: 'border-color 0.2s ease-in-out',
      minHeight: '280px',
      outline: 'none',
      background: 'transparent',
    },
    '.tox:not(.tox-tinymce-inline) .tox-editor-header': {
      background: 'transparent',
      boxShadow: 'none',
    },
    '&& .tox.tox-tinymce.tox-edit-focus, && .tox.tox-tinymce:focus': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.56',
      boxShadow: 'none',
      borderRadius: '4px',
      outline: 'none',
    },
    '&& .tox *:focus, && .tox-edit-area__iframe:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:hover .tox-tinymce': {
      borderColor: 'gray.56',
    },
    '& .tox-tinymce.tox-tinymce--disabled': {
      borderColor: 'gray.16',
      opacity: 0.7,
    },
    '& .tox-edit-area__iframe': {
      background: 'transparent',
      color: 'gray.80',
    },
    '& .tox-edit-area': {
      flex: '1 1 auto',
      minHeight: '120px',
      background: 'transparent',
      '&::before': {
        opacity: 0,
        border: 'none',
        display: 'none',
      },
    },
    '& .tox-statusbar': {
      background: 'transparent',
      border: 'none',
      color: 'gray.56',
    },
    '& .tox-toolbar-overlord': {
      background: 'transparent',
    },
    '& .tox-toolbar__primary': {
      background: 'transparent',
    },
    '& .tox-toolbar': {
      background: 'transparent',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: 'gray.8',
    },
    '& .tox-toolbar__group': {
      borderColor: 'transparent',
      background: 'transparent',
    },
    '& .tox-toolbar__overflow': {
      background: 'transparent',
    },
    '& .tox-tbtn': {
      color: 'gray.56',
      background: 'transparent',
      '&:hover': {
        backgroundColor: 'gray.3',
        color: 'gray.80',
      },
      '&:focus, &:focus-visible': {
        outline: 'none',
        boxShadow: 'none',
        border: 'none',
      },
      '& svg': {
        fill: 'gray.56',
      },
    },
    '& .tox-tbtn--enabled, & .tox-tbtn--enabled:hover': {
      backgroundColor: 'gray.8',
      color: (theme) => theme.palette.primary.main,
      '& svg': {
        fill: (theme) => theme.palette.primary.main,
      },
    },
    '& .tox-tbtn__select-label': {
      color: 'gray.56',
    },
    '& .tox-tbtn.tox-tbtn--select[aria-label="Insert shortcode"]': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      borderRadius: '4px',
      padding: '4px 8px',
    },
    '& .tox-tbtn.tox-tbtn--select[aria-label="Insert shortcode"] .tox-tbtn__select-label': {
      color: (theme) => theme.palette.primary.main,
      fontWeight: 500,
    },
    '& .tox-tbtn.tox-tbtn--select[data-mce-name="shortcodes"]': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      borderRadius: '4px',
      padding: '4px 8px',
    },
    '& .tox-tbtn.tox-tbtn--select[data-mce-name="shortcodes"] .tox-tbtn__select-label': {
      color: (theme) => theme.palette.primary.main,
      fontWeight: 500,
    },
    '& .tox-tbtn--enabled, & .tox-tbtn--enabled:focus, & .tox-tbtn:focus': {
      outline: 'none',
      boxShadow: 'none',
      border: 'none',
    },
    '& .tox-tbtn.tox-tbtn--select:focus, & .tox-tbtn.tox-tbtn--select.tox-tbtn--enabled': {
      outline: 'none',
      boxShadow: 'none',
    },
    '& .tox-tbtn.tox-tbtn--select[data-mce-name="shortcodes"]:focus, & .tox-tbtn.tox-tbtn--select[data-mce-name="shortcodes"]:focus-visible':
      {
        outline: 'none',
        boxShadow: 'none',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'gray.56',
      },
    '& .tox-button:focus, & .tox-button.tox-button--secondary:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '& .tox-collection__item': {
      color: 'gray.56',
      background: 'transparent',
    },
    '& .tox-collection__item--active': {
      backgroundColor: 'gray.3',
      color: 'gray.80',
    },
    '& .tox-collection__item:hover': {
      backgroundColor: 'gray.3',
      color: 'gray.80',
    },
    '&& .tox.tox-platform-touch': {
      borderRadius: '4px',
    },
    '& .tox-menu.tox-collection.tox-collection--list': {
      borderColor: 'gray.16',
      boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
    },
    '& .tox-collection__item-label': {
      color: 'gray.56',
      fontSize: '14px',
      fontFamily: (theme) => theme.typography.fontFamily,
    },

    '& .tox-menubar': {
      backgroundColor: 'transparent',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: 'gray.8',
    },
    '& .tox-mbtn': {
      color: 'gray.56',
      background: 'transparent',
      alignItems: 'center',
      '&:hover:not(:disabled)': {
        backgroundColor: 'gray.3',
        color: 'gray.80',
      },
      '&.tox-mbtn--active': {
        backgroundColor: 'gray.8',
        color: 'gray.80',
      },
      '&:focus, &:focus-visible': {
        outline: 'none',
        boxShadow: 'none',
      },
    },
    '& .tox-mbtn__select-label': {
      color: 'gray.56',
      fontSize: '14px',
      fontFamily: (theme) => theme.typography.fontFamily,
    },
    '& .tox-menu': {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
    },
    '& .tox-collection--list .tox-collection__group': {
      borderColor: 'gray.8',
    },
    '& .tox-collection__group-heading': {
      color: 'gray.48',
      fontSize: '13px',
      fontWeight: 500,
    },
    '& .tox-menu.tox-collection.tox-collection--list .tox-collection__item': {
      color: 'gray.56',
      fontSize: '14px',
      padding: '6px 12px',
      '&:hover': {
        backgroundColor: 'gray.3',
        color: 'gray.80',
      },
      '&.tox-collection__item--active': {
        backgroundColor: 'gray.8',
        color: 'gray.80',
      },
      '&:focus, &:focus-visible': {
        outline: 'none',
        boxShadow: 'none',
      },
    },
    '& .tox-collection__item-icon, & .tox-collection__item-checkmark': {
      color: 'gray.56',
      '& svg': {
        fill: 'gray.56',
      },
    },
    '& .tox-collection__item-accessory': {
      color: 'gray.48',
      fontSize: '13px',
    },
    '& .tox-dialog': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      borderRadius: '4px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
      background: 'transparent',
    },
    '& .tox-dialog__header': {
      backgroundColor: 'transparent',
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: 'gray.8',
      padding: '12px 16px',
    },
    '& .tox-dialog__title': {
      color: 'gray.80',
      fontFamily: (theme) => theme.typography.fontFamily,
      fontSize: '16px',
      fontWeight: 500,
    },
    '& .tox-dialog__body': {
      backgroundColor: 'transparent',
      color: 'gray.80',
    },
    '& .tox-dialog__body-content': {
      padding: '16px',
      background: 'transparent',
    },
    '& .tox-dialog__footer': {
      backgroundColor: 'transparent',
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: 'gray.8',
      padding: '12px 16px',
    },
    '& .tox-label, & .tox-toolbar-label': {
      color: 'gray.56',
      fontFamily: (theme) => theme.typography.fontFamily,
      fontSize: '14px',
      fontWeight: 400,
      margin: '0 0 4px 0',
    },
    '& .tox-textfield, & .tox-selectfield select, & .tox-textarea': {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.16',
      borderRadius: '4px',
      color: 'gray.80',
      fontFamily: (theme) => theme.typography.fontFamily,
      fontSize: '14px',
      padding: '8px 12px',
      '&:focus': {
        borderColor: 'gray.56',
        boxShadow: 'none',
      },
    },
    '& .tox-button': {
      backgroundColor: (theme) => theme.palette.primary.main,
      color: 'gray.0',
      borderRadius: '4px',
      borderStyle: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 500,
      padding: '8px 16px',
      '&:hover:not(:disabled)': {
        backgroundColor: (theme) => theme.palette.primary.dark,
      },
      '&.tox-button--secondary': {
        backgroundColor: 'gray.16',
        color: 'gray.80',
        '&:hover:not(:disabled)': {
          backgroundColor: 'gray.24',
        },
      },
    },
  },

  shortcodeButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
}

export const getDefaultStyle = (theme) => `
  body {
    font-family: ${theme.typography.fontFamily};
    font-size: 14px;
    font-weight: 400;
    color: 'gray.80';
    padding: 12px 16px;
    min-height: 150px;
    box-sizing: border-box;
    background: transparent;
  }
  p {
    margin: 0 0 0.75em 0;
    padding: 0;
    line-height: 1.5;
  }
  p:last-child {
    margin-bottom: 0;
  }
`

export const getShortcodeStyles = (theme) => `
  span.shortcode {
    background-color: ${theme.palette.primary.lightest};
    border: none;
    padding: 2px 4px;
    margin: 0 2px;
    white-space: nowrap;
    cursor: default;
    font-weight: 600;
    color: ${theme.palette.primary.main};
    border-radius: 2px;
  }
`
